import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import DataRoomEmptyImage from 'assets/images/data-room-upload.webp';
import { useTranslation } from 'react-i18next';
import { ConditionalLink } from 'components/ConditionalLink';
import PlusIcon from 'icons/Plus.icon';
import { useNavigate } from 'react-router-dom';
import ListingContext from '../../../../providers/Listing/Listing.context';
import { BUTTON_CLASSES } from '../MarketYourDeal/MarketYourDeal.component';
import { getCreateDealRoute } from 'utils';

import './DataRoomIsLockedUserCard.styles.scss';
import './DataRoomIsLockedUserCard.styles.responsive.scss';

type DataRoomIsLockedUserCardProps = {
  className?: string;
};

const DataRoomIsLockedUserCard: React.FC<DataRoomIsLockedUserCardProps> = (
  props,
) => {
  const { className } = props;

  const {
    areActionsDisabled,
    dealRoom: { _id: dealId },
  } = useContext(ListingContext);

  const classes = classNames(
    'data-room-is-locked-user-card',
    { disabled: areActionsDisabled },
    className,
  );

  const listingUrl = getCreateDealRoute(dealId, true, 'market-listing');

  const navigate = useNavigate();

  const handleOnClick = useCallback(() => {
    if (areActionsDisabled) return;
    navigate(listingUrl);
  }, [areActionsDisabled, listingUrl, navigate]);

  const { t } = useTranslation();

  return (
    <div className={classes} onClick={handleOnClick}>
      <div className="card-heading">
        <p>{t('dataRoomIsLocked')}</p>
        <p>{t('createListingToUnlockTheDataRoom')}</p>
      </div>

      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="Upload files to Data room"
      />

      <ConditionalLink
        isDisabled={areActionsDisabled}
        disabledClassName={BUTTON_CLASSES}
        linkClassName={BUTTON_CLASSES}
        to={listingUrl}
      >
        {t('createAListing')}
        <PlusIcon />
      </ConditionalLink>
    </div>
  );
};

export default DataRoomIsLockedUserCard;
